
                <div class="busyLine">
                    <progress-indicator-bar *ngIf="showBusyLine" indicatorClass="blockLoader fromLeft"></progress-indicator-bar>
                </div>
                <div class="messages">
                    <div class="msgCount" *ngIf="statusBarMessages && statusBarMessages.length > 1" (click)="toggle()">{{statusBarMessages.length}}</div>
                    <div class="msg" *ngFor="let message of statusBarMessages; trackBy:trackByMessage">{{message.messageText}}</div>
                </div>
              